var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-notification-item",
    {
      attrs: {
        icon: _vm.value.getIcon(),
        tone: _vm.value.getTone(),
        unread: !_vm.value.IsRead,
        time: _vm.time,
        clickable: "",
      },
      on: {
        click: function ($event) {
          return _vm.onItemClick()
        },
      },
    },
    [
      _c(
        "template",
        { slot: "title" },
        [
          _vm._v(" " + _vm._s(_vm.value.getTitle()) + " "),
          _vm.count > 1
            ? [
                _c("span", { staticClass: "repeat-count" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("views.NotificationsModal.repeated", {
                        count: _vm.count,
                      })
                    )
                  ),
                ]),
                _c("w-fa", {
                  staticClass: "repeat-chevron",
                  attrs: { icon: _vm.expanded ? "angle-up" : "angle-down" },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "template",
        { slot: "time" },
        [
          _vm._v(" " + _vm._s(_vm.time) + " "),
          _vm.showHideForClientButton
            ? _c("w-button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.hideTooltip,
                    expression: "hideTooltip",
                  },
                ],
                attrs: { ghost: "", round: "", icon: _vm.hideIcon },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onHideClick()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "subtitle" },
        [
          _vm.isJobStoppedMessage
            ? [
                _vm._v(
                  _vm._s(
                    _vm.$t("common.notifications.job-stopped", _vm.value.Data)
                  )
                ),
              ]
            : _vm.value.Type == "error"
            ? [
                _vm._v(
                  _vm._s(
                    _vm.displayError
                      ? _vm.message
                      : _vm.$t("common.notifications.title-display-error")
                  )
                ),
              ]
            : [_vm._v(_vm._s(_vm.message))],
        ],
        2
      ),
      _vm.actionLabel
        ? _c(
            "w-button",
            {
              attrs: { sm: "" },
              on: {
                click: function ($event) {
                  return _vm.onClick()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.actionLabel) + " ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }